import { CSSProperties } from "react";

export const styles: Record<string, CSSProperties> = {
  loader: {
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
};
